export interface LocallyStoredRegistrationData {
  brand: string;
  modelNumber: string | null;
  purchaseDate: string | Date | null;
  purchaseFrom?: string;
  purchasePrice: string | null;
  serialNumber: string | null;
  type: string;
}
